export default __webpack_public_path__ + "static/media/careadmin_girl.54799152.svg";